/* eslint-disable no-use-before-define */
import geraData from '../geradata';

export default function dadosTabelas() {
  /*
  nomeapi: => { opcional } NOME DA TABELA NA API,
  campoatt: => CAMPO PARA UTILIZAR NA HORA DA ATUALIZACAO,
  prefixo: => PREFIXO DA TABELA LOCAL,
  model => MODEL DO BANCO LOCAL,
  */
  return {
    movimentacaoveiculo: {
      campoatt: 'movdataalteracao',
      prefixo: 'mov',
      model: movimentacaoveiculo,
    },
    veiculo: {
      campoatt: 'veidataatualizacao',
      prefixo: 'vei',
      model: veiculo,
    },
    eventosveiculos: {
      nomeapi: 'eventosveiculo',
      campoatt: 'evvdataalteracao',
      prefixo: 'evv',
      model: eventosveiculos,
    },
    itemmovimentacaoveiculo: {
      campoatt: 'imvdataalteracao',
      prefixo: 'imv',
      model: itemmovimentacaoveiculo,
    },
    veiculoatividade: {
      campoatt: 'veadataalteracao',
      prefixo: 'vea',
      model: veiculoatividade,
    },
  };
}

export function movimentacaoveiculo(item) {
  const dataBruta = item.movdataalteracao || item.movdatanuvem || item.movdataenvio || item.movdata;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAlt = (item.movdataalteracao ? geraData(item.movdataalteracao) : null) || dataFallback;
  const dataNuv = (item.movdatanuvem ? geraData(item.movdatanuvem) : null) || dataAlt;
  return {
    movidnuvem: item.id,
    movidmovimentacaoveiculo: item.movidmovimentacaoveiculo,
    movidveiculo: item.movidveiculo,
    movideventoveiculo: item.movideventoveiculo,
    movidfornecedor: item.movidfornecedor,
    movvalortipo: item.movvalortipo,
    movdata: item.movdata ? (geraData(item.movdata) || item.movdata) : dataFallback,
    movobservacao: item.movobservacao,
    movtipo: item.movtipo,
    movtipomanutencao: item.movtipomanutencao,
    movidpessoaexecutor: item.movidpessoaexecutor,
    movidpropriedade: item.movidpropriedade,
    movgarantiaate: item.movgarantiaate ? geraData(item.movgarantiaate) : null,
    movidatividade: item.movidatividade,
    movidempresa: item.movidempresa,
    movdatanuvem: dataNuv,
    movdataalteracao: dataAlt,
    movidmovimentacaonuvem: item.movidmovimentacaonuvem,
    movdeletar: item.movdeletar ?? 0,
    movenviado: item.movenviado || null,
    enviado: item.enviado || null,
  };
}

export function veiculo(item) {
  const dataBruta = item.veidataatualizacao || item.veidataalteracao || item.veidatanuvem;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAtt = (item.veidataatualizacao ? geraData(item.veidataatualizacao) : null) || dataFallback;
  const dataAlt = (item.veidataalteracao ? geraData(item.veidataalteracao) : null) || dataAtt;
  const dataNuv = (item.veidatanuvem ? geraData(item.veidatanuvem) : null) || dataAtt;
  return {
    veiidnuvem: item.id,
    veiidveiculo: item.veiidveiculo,
    veifrota: item.veifrota,
    veimarca: item.veimarca,
    veiplaca: item.veiplaca,
    veiplacacomplementar: item.veiplacacomplementar,
    veitipo: item.veitipo,
    veitipomaquinario: item.veitipomaquinario,
    veidataatualizacao: dataAtt,
    veidatanuvem: dataNuv,
    veidataalteracao: dataAlt,
    veiidveiculonuvem: item.veiidveiculonuvem,
    veideletar: item.veideletar ?? 0,
  };
}

export function eventosveiculos(item) {
  const dataBruta = item.evvdataalteracao || item.evvdatanuvem;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAlt = (item.evvdataalteracao ? geraData(item.evvdataalteracao) : null) || dataFallback;
  const dataNuv = (item.evvdatanuvem ? geraData(item.evvdatanuvem) : null) || dataAlt;
  return {
    evvidnuvem: item.id,
    evvideventoveiculo: item.evvideventoveiculo,
    evvdescricao: item.evvdescricao,
    evvinativo: item.evvinativo,
    evvdataalteracao: dataAlt,
    evvdatanuvem: dataNuv,
    evvideventoveiculosnuvem: item.evvideventoveiculosnuvem,
    evvdeletar: item.evvdeletar ?? 0,
  };
}

export function itemmovimentacaoveiculo(item) {
  const dataBruta = item.imvdataalteracao || item.imvdatanuvem || item.imvdataenvio;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAlt = (item.imvdataalteracao ? geraData(item.imvdataalteracao) : null) || dataFallback;
  const dataNuv = (item.imvdatanuvem ? geraData(item.imvdatanuvem) : null) || dataAlt;
  return {
    imvidnuvem: item.id,
    imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo,
    imvidmovimentacaoveiculo: item.imvidmovimentacaoveiculo,
    imvidmovimentacaonuvem: item.imvidmovimentacaonuvem,
    imvtiposervico: item.imvtiposervico,
    imvidproduto: item.imvidproduto,
    imvdescricaoproduto: item.imvdescricaoproduto,
    imvunidadedemedida: item.imvunidadedemedida,
    imvquantidade: item.imvquantidade,
    imvprecounitario: item.imvprecounitario,
    imvidlocalarmazenamento: item.imvidlocalarmazenamento,
    imvobservacao: item.imvobservacao,
    imvvalortotal: item.imvvalortotal,
    imvdataalteracao: dataAlt,
    imvdatanuvem: dataNuv,
    imviditemmovimentacaoveiculonuvem: item.imviditemmovimentacaoveiculonuvem,
    imvdeletar: item.imvdeletar ?? 0,
    imvenviado: item.imvenviado || null,
    enviado: item.enviado || null,
  };
}

export function veiculoatividade(item) {
  const dataBruta = item.veadataalteracao || item.veadatanuvem;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAlt = (item.veadataalteracao ? geraData(item.veadataalteracao) : null) || dataFallback;
  const dataNuv = (item.veadatanuvem ? geraData(item.veadatanuvem) : null) || dataAlt;
  return {
    veaidnuvem: item.id,
    veaidveiculoatividade: item.veaidveiculoatividade,
    veadescricao: item.veadescricao,
    veainativo: item.veainativo,
    veadataalteracao: dataAlt,
    veadatanuvem: dataNuv,
    veaidveiculoatividadenuvem: item.veaidveiculoatividadenuvem,
    veadeletar: item.veadeletar ?? 0,
  };
}
